import React from 'react';

const VideoDefaultScreen = () => {
  return (
    <div className={'ml-video-player type-default-screen'}>
      <figure className={'player-thumbnail'}>
        <img src={'/images/img_no_img.png'} alt='player-thumbnail-image' className={'player-thumbnail-img'} />
      </figure>
    </div>
  );
};

export default VideoDefaultScreen;
